<template>
  <v-data-table v-if="items"
                :items="items"
                :search="search"
                :headers="headers"
  />
</template>

<script>
export default {
  name: "TerminalLogTable",
  props: {
    items: Array,
    search: String
  },
  data: () => ({
    headers: [
      {text: 'Название товара', value: 'ProductName'},
      {text: 'Количество в тоннах', value: 'Tons'},
      {text: 'Комментарий', value: 'Comment'},
      {text: 'Дата', value: 'd'},
    ]

    // public string ProductId { get; set; }
    // public string ProductName { get; set; }
    // public bool IsWriteOff { get; set; }
    // public double Tons { get; set; }
    // public string Comment { get; set; }
  })
}
</script>
